
// @ts-nocheck
/* eslint-disable */
import { hasClass } from '@/components/utils/dom'
import { rangeArr } from '@/components/time-picker'
import { coerceTruthyValueToArray } from '@/components/utils/util'
import {
  defineComponent,
  computed,
  PropType
} from 'vue'
import dayjs, { Dayjs } from 'dayjs'

const datesInYear = year => {
  const firstDay = dayjs(String(year)).startOf('year')
  const lastDay = firstDay.endOf('year')
  const numOfDays = lastDay.dayOfYear()
  return rangeArr(numOfDays).map(n => firstDay.add(n, 'day').toDate())
}

export default defineComponent({
  props: {
    disabledDate: {
      type: Function as PropType<(_: Date) => void>
    },
    parsedValue: {
      type: Object as PropType<Dayjs>
    },
    date: {
      type: Object as PropType<Dayjs>
    }
  },

  emits: ['pick'],

  setup (props, ctx) {
    const startYear = computed(() => {
      return Math.floor(props.date.year() / 10) * 10
    })
    const getCellStyle = year => {
      const style = {} as any
      const today = dayjs()

      style.disabled = props.disabledDate
        ? datesInYear(year).every(props.disabledDate)
        : false

      style.current = coerceTruthyValueToArray(props.parsedValue).findIndex(_ => _.year() === year) >= 0

      style.today = today.year() === year

      return style
    }

    const handleYearTableClick = event => {
      const target = event.target
      if (target.tagName === 'A') {
        if (hasClass(target.parentNode, 'disabled')) return
        const year = target.textContent || target.innerText
        ctx.emit('pick', Number(year))
      }
    }
    return {
      startYear,
      getCellStyle,
      handleYearTableClick
    }
  }
})
